import _asyncToGenerator from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/opt/buildhome/repo/node_modules/@babel/runtime/regenerator";
import delay from 'yoctodelay';
export default function pMinDelay(_x, _x2) {
  return _pMinDelay.apply(this, arguments);
}

function _pMinDelay() {
  _pMinDelay = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(promise, minimumDelay) {
    var _ref,
        _ref$delayRejection,
        delayRejection,
        delayPromise,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref = _args.length > 2 && _args[2] !== undefined ? _args[2] : {}, _ref$delayRejection = _ref.delayRejection, delayRejection = _ref$delayRejection === void 0 ? true : _ref$delayRejection;
            delayPromise = delay(minimumDelay);
            _context.next = 4;
            return delayRejection ? delayPromise : Promise.all([promise, delayPromise]);

          case 4:
            return _context.abrupt("return", promise);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _pMinDelay.apply(this, arguments);
}